module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'h1') ? _c('h1', {
    class: _vm.className
  }, [_vm._t("default")], 2) : (_vm.type === 'h2') ? _c('h2', {
    class: _vm.className
  }, [_vm._t("default")], 2) : (_vm.type === 'h3') ? _c('h3', {
    class: _vm.className
  }, [_vm._t("default")], 2) : (_vm.type === 'h4') ? _c('h4', {
    class: _vm.className
  }, [_vm._t("default")], 2) : (_vm.type === 'h5') ? _c('h5', {
    class: _vm.className
  }, [_vm._t("default")], 2) : (_vm.type === 'h6') ? _c('h6', {
    class: _vm.className
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ebe842b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Heading.vue
// module id = 124
// module chunks = 0